module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-edit"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/safety_confirmations"
    }
  }, [_vm._v(_vm._s(_vm.$t('Safety Confirmation List')))])], 1), (_vm.isEdit) ? _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Safety Confirmation Edit')))])]) : _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Safety Confirmation New')))])])]), (_vm.isEdit) ? _c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('Safety Confirmation Edit')))]) : _c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('Safety Confirmation New')))]), _c('form', {
    staticClass: "form-horizontal"
  }, [
    [_c('div', {
      staticClass: "row margin-top"
    }, [_c('label', {
      staticClass: "col-sm-3 control-label"
    }, [_vm._v("対象店舗")]), _c('div', {
      staticClass: "col-sm-9"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.safetyConfirmationAllCheck),
        expression: "safetyConfirmationAllCheck"
      }],
      staticStyle: {
        "margin-right": "5px"
      },
      attrs: {
        "type": "checkbox",
        "id": "service-question-user-type-all-check",
        "disabled": _vm.isClosed ? 'disabled' : false
      },
      domProps: {
        "checked": Array.isArray(_vm.safetyConfirmationAllCheck) ? _vm._i(_vm.safetyConfirmationAllCheck, null) > -1 : (_vm.safetyConfirmationAllCheck)
      },
      on: {
        "click": [function($event) {
          var $$a = _vm.safetyConfirmationAllCheck,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.safetyConfirmationAllCheck = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.safetyConfirmationAllCheck = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.safetyConfirmationAllCheck = $$c
          }
        }, _vm.safetyConfirmationAllChecked]
      }
    }), _c('label', {
      attrs: {
        "for": "service-question-user-type-all-check"
      }
    }, [_vm._v("全選択")])])]), _vm._l((_vm.areas), function(area) {
      return [_c('div', {
        staticClass: "row margin-top"
      }, [_c('div', {
        staticClass: "col-sm-3"
      }), _c('div', {
        staticClass: "col-sm-9"
      }, [_c('input', {
        staticStyle: {
          "margin-right": "5px"
        },
        attrs: {
          "type": "checkbox",
          "id": 'safety_confirm_area_' + area.id,
          "disabled": _vm.isClosed ? 'disabled' : false
        },
        domProps: {
          "checked": _vm.safetyConfimationAreaIds.indexOf(area.id) >= 0,
          "value": area.id
        },
        on: {
          "click": function($event) {
            _vm.safetyConfirmationAreaChecked(area.id)
          }
        }
      }), _c('label', {
        attrs: {
          "for": 'safety_confirm_area_' + area.id
        }
      }, [_vm._v(_vm._s(area.attributes['name']) + "エリア")])])]), _c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-sm-3"
      }), _c('div', {
        staticClass: "col-sm-9"
      }, [_c('div', {
        staticClass: "row"
      }, _vm._l((area.attributes.shops), function(shop, index) {
        return _c('div', {
          staticClass: "col-sm-4"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.safetyConfimationShopIds),
            expression: "safetyConfimationShopIds"
          }],
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "type": "checkbox",
            "id": 'safety_confirm_shop_' + area.id + '_' + index,
            "disabled": _vm.isClosed ? 'disabled' : false
          },
          domProps: {
            "value": shop.id,
            "checked": Array.isArray(_vm.safetyConfimationShopIds) ? _vm._i(_vm.safetyConfimationShopIds, shop.id) > -1 : (_vm.safetyConfimationShopIds)
          },
          on: {
            "click": function($event) {
              var $$a = _vm.safetyConfimationShopIds,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = shop.id,
                  $$i = _vm._i($$a, $$v);
                if ($$c) {
                  $$i < 0 && (_vm.safetyConfimationShopIds = $$a.concat($$v))
                } else {
                  $$i > -1 && (_vm.safetyConfimationShopIds = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.safetyConfimationShopIds = $$c
              }
            }
          }
        }), _c('label', {
          attrs: {
            "for": 'safety_confirm_shop_' + area.id + '_' + index
          }
        }, [_vm._v(_vm._s(shop['name']))])])
      }))])])]
    }), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.validation.safetyConfimationShopIds),
        expression: "!validation.safetyConfimationShopIds"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.check')))])], (!_vm.isClosed) ? _c('div', {
      staticClass: "row margin-top"
    }, [_c('div', {
      staticClass: "col-sm-12 text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.isTraining),
        expression: "isTraining"
      }],
      staticStyle: {
        "margin-right": "5px"
      },
      attrs: {
        "type": "checkbox",
        "id": "is-training-check",
        "disabled": _vm.isEdit ? 'disabled' : false
      },
      domProps: {
        "checked": Array.isArray(_vm.isTraining) ? _vm._i(_vm.isTraining, null) > -1 : (_vm.isTraining)
      },
      on: {
        "click": function($event) {
          var $$a = _vm.isTraining,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.isTraining = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.isTraining = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.isTraining = $$c
          }
        }
      }
    }), _vm._m(0)]), (_vm.isEdit) ? _c('div', {
      staticClass: "col-sm-12 text-center"
    }, [_c('a', {
      staticClass: "btn btn-lg btn-danger",
      class: {
        disabled: !_vm.validation.safetyConfimationShopIds
      },
      staticStyle: {
        "margin-right": "5px"
      },
      on: {
        "click": function($event) {
          _vm.onClickUpdate()
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('Safety Confirmation Update')))])])]) : _c('div', {
      staticClass: "col-sm-12 text-center"
    }, [_c('a', {
      staticClass: "btn btn-lg btn-danger",
      class: {
        disabled: !_vm.validation.safetyConfimationShopIds
      },
      staticStyle: {
        "margin-right": "5px"
      },
      on: {
        "click": function($event) {
          _vm.onClickSave()
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('Safety Confirmation Save')))])])])]) : _vm._e(), (_vm.isEdit && !_vm.isClosed) ? _c('div', {
      staticClass: "row margin-top"
    }, [_c('div', {
      staticClass: "col-sm-12 text-center"
    }, [_c('a', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          _vm.onClickClose()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close"
    }), _c('span', [_vm._v(_vm._s(_vm.$t('Safety Confirmation Close')))])])])]) : _vm._e()
  ], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "is-training-check"
    }
  }, [_c('span', [_vm._v("安否確認を")]), _c('strong', [_vm._v("訓練")]), _c('span', [_vm._v("として公開する")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-22ccf3a7!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SafetyConfirmationEdit.vue
// module id = 777
// module chunks = 1